"use client";

import { ShoppingCart } from "@repo/ui/components/icons";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import Link from "next/link";
import { useEffect, useState } from "react";

import { CART_CHANGED_EVENT, getCartCount } from "../../lib/api-client";

// Header cart entry (desktop pill). Public /cart, since the cart works before
// sign-in (plan 2.6). Shown only while the cart holds something: it loads the
// count once and then follows CART_CHANGED_EVENT, which every cart call fires.
export function CartButton({ className }: { className?: string }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    getCartCount()
      .then(({ data }) => data && setCount(data.count))
      .catch(() => undefined);
    const onChange = (event: Event) => setCount((event as CustomEvent<{ count: number }>).detail.count);
    window.addEventListener(CART_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(CART_CHANGED_EVENT, onChange);
  }, []);

  if (count === 0) return null;

  return (
    <Button asChild variant="outline" size="icon" className={cn("relative rounded-full [&_svg]:size-[18px]", className)}>
      <Link href="/cart" aria-label={`سبد خرید، ${count.toLocaleString("fa-IR")} کالا`}>
        <ShoppingCart />
        <span className="bg-primary text-primary-foreground absolute -end-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-caption font-bold">
          {count > 99 ? "۹۹+" : count.toLocaleString("fa-IR")}
        </span>
      </Link>
    </Button>
  );
}
